const icon = require('vue-svgicon');
icon.register({
    'caret-left': {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M14.77 7.39L9.736 12l5.035 4.61a.423.423 0 11-.6.6l-5.312-4.864c-.021-.015-.05-.01-.07-.029a.42.42 0 01-.12-.316.419.419 0 01.12-.319c.02-.02.05-.014.073-.03l5.31-4.862a.423.423 0 11.6.6z" _fill="#000"/>`,
    },
});
